<template>
  <v-container>
    <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
    <h1 class="headline pb-4 mx-lg-auto">{{ person.title || 'New Organisation' }}</h1>
    <v-tabs v-model="tabs" background-color="transparent">
      <v-tab exact-path :to="'/people/' + person.id">Details</v-tab>
      <v-tab exact-path :to="'/people/' + person.id + '/subgroups'" v-if="person.id > 0">Sub Groups</v-tab>
    </v-tabs>
    <v-card>
      <v-card-text>
        <v-tabs-items v-model="tabs" transition="false">
          <v-card flat>
            <v-card-text>
              <router-view />
            </v-card-text>
          </v-card>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '@/store/index';

export default {
  name: 'PersonView',
  beforeRouteEnter(to, from, next) {
    store.dispatch('person/get', to.params.id).then(() => {
      next();
    });
  },
  computed: {
    ...mapGetters('person', ['loading', 'error', 'person', 'meta'])
  },
  data: () => ({
    tabs: null,
    breadcrumbs: [
      {
        text: 'Dashboard',
        exact: true,
        to: '/dashboard'
      },
      {
        text: 'People',
        exact: true,
        to: '/people'
      },
      {
        text: 'Person',
        disabled: true,
        exact: true,
        to: '/people/:id'
      }
    ]
  })
};
</script>
